import axios from "@/plugins/axios";
export default {
  domainUsed: (data) =>
    axios.post(`/validate-domain`, data).then((response) => response.data),
  uploadImage: (data) =>
    axios.post(`/files/upload-preview`, data).then((response) => response.data),
};
